import {Component, OnDestroy, OnInit} from '@angular/core';
import {ICollaborationProviderComponent} from '@shared/components/platform-sidebar/store/view-synchronizer.interfaces';
import {CollaborationState} from '../../store/collaboration.reducer';
import {Store} from '@ngrx/store';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {ViewSynchronizerService} from '@shared/components/platform-sidebar/store/view-synchronizer.service';
import {CollaborationConfig} from '../../store/collaboration.config';
import {CollaborationQuery} from '../../store/collaboration.query';
import {
  GetContextByPathAction, GetContextByPathSuccessAction, GetContextWithConversationListByPathAction,
  GetConversationAction, GetConversationChatAction,
  GetConversationListAction
} from '../../store/collaboration.action';
import {getContextByPath} from '../../store/collaboration.selector';
import {
  CollaborationConversationListComponentName,
  FieldConversationComponentName
} from '../../store/collaboration.constants';
import {ContentScope} from '@shared/commands/command-base';
import {GraphqlContentScope} from '@shared/models/graphql-content-scope.model';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { FuseSidebarService } from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';

@Component({
    standalone: false,
    selector: 'particle-collaboration-conversation-list',
  templateUrl: './collaboration-conversation-list.component.html',
  styleUrls: ['./collaboration-conversation-list.component.scss']
})
export class CollaborationConversationListComponent implements OnInit, ICollaborationProviderComponent, OnDestroy {
  contextByPath$: any;
  conversationList: any;
  contextTitle: any;
  data: any;
  contextId: string;
  collaborationComponentName: string;
  conversationListComponentName: string;
  private ngUnsubscribe = new Subject<void>();

  constructor (private collaborationStore: Store<CollaborationState>,
               private platformSidebarStore: Store<PlatformSidebarState>,
               private viewSynchronizerService: ViewSynchronizerService,
               private sidebarService: FuseSidebarService) {
    this.contextId = 'dummyToStopConversationListToPreventCall.ThisAllHaveBeenDoneToUseASingleComponent';
    this.viewSynchronizerService.setProvider(this);
    this.collaborationComponentName = FieldConversationComponentName;
    this.conversationListComponentName = CollaborationConversationListComponentName;
  }

  ngOnInit() {
    if (this.data && this.data.contextId) {
      this.getConversationList();
    } else {
      this.data = this.viewSynchronizerService.getCurrentContextFromConsumer();
      if (this.data && this.data.contextId) {
        this.getConversationList();
      }
    }
    //this.subscribeToContextByPath();
  }

  setComponentToInitialState() {
  }

  getConversationList () {
    // this.openRightSidebar(); // If someone close rightsidebar. this will be use to reopen for conversation list
    this.contextId = this.data.contextId;
    this.collaborationStore.dispatch(new GetContextWithConversationListByPathAction(CollaborationConfig.CollaborationApiKey,
      CollaborationQuery.getContextWithConversationListByPath(this.data.contextId,
      GraphqlContentScope.getScope(ContentScope.Default)), CollaborationConversationListComponentName));
  }

  subscribeToContextByPath () {
    this.contextByPath$ = this.collaborationStore.select(getContextByPath).pipe(
      takeUntil(this.ngUnsubscribe));
    this.contextByPath$.subscribe(contextByPath => {
      if (contextByPath && contextByPath.conversations) {
        this.contextTitle = contextByPath.title;
        this.conversationList = contextByPath.conversations;
      } else {
        this.contextTitle = '';
        this.conversationList = [];
      }
    });
  }

  navigateToConversation(conversation) {
    this.viewSynchronizerService.bringIntoView(conversation.id, conversation.sourceInfo);
    this.collaborationStore.dispatch(new GetConversationChatAction(CollaborationConfig.CollaborationApiKey,
      CollaborationQuery.getChatConversationById(conversation.id , conversation.contentScope), FieldConversationComponentName));
  }

  setCurrentContext(contextId) {
    this.data = contextId;
    if (this.data && this.data.contextId) {
      this.getConversationList();
    } else {
      this.collaborationStore.dispatch(new GetContextByPathSuccessAction({contextByPath : null}, 'CollaborationConversationListComponent'));
    }
  }

  setCurrentConversation(conversationId) {
  }

  postMessage(conversationId, message) {
  }

  ngOnDestroy() {
    this.viewSynchronizerService.setProvider(null);
    this.collaborationStore.dispatch(new GetContextByPathSuccessAction({contextByPath : null}, null));
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
